import { render, staticRenderFns } from "./MemoirProfilePublications.vue?vue&type=template&id=7a76e490&"
import script from "./MemoirProfilePublications.vue?vue&type=script&lang=js&"
export * from "./MemoirProfilePublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports